import { getDeviceId } from '@24i/nxg-core-utils';
import type { AdvertisingInfo } from './common';
import { OneTrust } from '../../../utils/oneTrust';

export const getAdvertisingInfo = async (): Promise<AdvertisingInfo> => {
    const deviceId = await getDeviceId();
    const oneTrustConsent = await OneTrust?.getConsentStatus();

    const doNotTrack = oneTrustConsent?.doNotTrack === true || navigator.doNotTrack === '1';
    // idType: lat == 1 OR dnt == 1 then the value must null
    const idType = doNotTrack ? null : 'sessionId';
    return {
        advertisingId: deviceId,
        idType,
        doNotTrack,
        isAdTrackingLimited: null, // is null for web
        tcfConsent: oneTrustConsent?.tcfConsentString || null,
        gppString: oneTrustConsent?.gppConsentString || null,
        gppSid: oneTrustConsent?.gppSectionId || null,
    };
};
